import { render, staticRenderFns } from "./monthsDetail.vue?vue&type=template&id=5e4e578a&scoped=true"
import script from "./monthsDetail.vue?vue&type=script&lang=js"
export * from "./monthsDetail.vue?vue&type=script&lang=js"
import style0 from "./monthsDetail.vue?vue&type=style&index=0&id=5e4e578a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e578a",
  null
  
)

export default component.exports